import React from "react";
import BUSINESS from "../config/business";

export default function Footer() {
  const year = new Date().getFullYear();
  const validEmail = /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(BUSINESS.email || "");
  const isLive = Boolean(BUSINESS.live && validEmail);
  return (
    <footer className="footer">
      <div className="wrap">
        <div className="footer-top">
          <strong>JKM COASTAL CARPENTRY &amp; CONSTRUCTION LLC</strong>
          <span className="footer-tagline">Small projects. Experienced hands.</span>
        </div>
        <div className="footer-bottom">
          <span>Wells, ME &bull; Serving Portland, ME to Portsmouth, NH &bull; Insured &bull; COI on request</span>
          <span>
            &copy; <span id="year">{year}</span> JKM Coastal Carpentry &nbsp;
            {BUSINESS.googleReviewUrl && (
              <>
                <a href={BUSINESS.googleReviewUrl} target="_blank" rel="noopener noreferrer">Review us on Google &uarr;</a>
                &nbsp;&bull;&nbsp;
              </>
            )}
            {BUSINESS.googleProfileUrl && (
              <>
                <a href={BUSINESS.googleProfileUrl} target="_blank" rel="noopener noreferrer">Find us on Google &uarr;</a>
                &nbsp;&bull;&nbsp;
              </>
            )}
            <a href="#top">Back to top &uarr;</a>
          </span>
        </div>
        <details className="privacy">
          <summary>About project inquiries and this website</summary>
          <p>
            This supplied website has no analytics, advertising scripts, cookies, or remote form database. In preview mode, information entered remains in the page until it is closed or refreshed. When live email contact is configured, the form opens your own email app; the request is not sent until you send that email. Hosting and email providers may process technical logs or messages under their own policies. Review this notice if the website&apos;s tools or hosting change.
          </p>
        </details>
        {!isLive && (
          <p className="footer-draft">DRAFT: proposed branding and service area. Customer-review and project-photography claims have not been added.</p>
        )}
      </div>
    </footer>
  );
}
